﻿// Obsolete component
import React, { Fragment, useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../features/axiosHelper";
import {
  Card,
  Checkbox,
  Container,
  Typography,
  Stack,
  Button,
  Box,
  Grid,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
  TextField,
} from "@mui/material";
import Dropdown from "@/components/Dropdown/Dropdown";
import MainNavigation from "@/components/MainNavigation/MainNavigation";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import OperationsNavigation from "@/components/OperationsNavigation/OperationsNavigation";
import StageCheckbox from "./StageCheckbox";
import "./Settings.css";
import SummaryCard from "./SummaryCard";
import PopUp from "@/components/PopUp/PopUp";
import IconButton from "@/components/IconButton/IconButton";
import {
  ChangeConnectionProfileInactive,
  GlobalSettingInactive,
  ProcessConfirmationHover,
  ProcessConfirmationInactive,
  ProcessSettingsHover,
  ProcessSettingsInactive,
  ReceiveSettingsHover,
  ReceiveSettingsInactive,
  SaveHover,
  SaveInactive,
} from "../../ImageRepo";
import SettingsPopUp from "./SettingsPopUp";
import { Link } from "react-router-dom";
import MenuBlock from "@/components/MenuBlock/MenuBlock";
import {
  selectCurrentCycleId,
  selectCurrentOperationId,
  selectCurrentOperationName,
  selectCurrentConnectionPair,
} from "@/features/operations/operationsSlice";
import {
  selectConnectionProfile,
  selectGlobalProfile,
  getConnectionProfileStatus,
  getGlobalProfileStatus,
  fetchConnectionProfile,
  fetchGlobalProfile,
  updateOption,
  setConnectionProfile,
} from "@/features/settings/settingsSlice";

const CatalogGridCard = ({ optionSchema, profileOption, isGlobal }) => {
  const dispatch = useDispatch();
  const applyNewCatalogValue = (catalogId, value) => {
    let optionValue = JSON.parse(profileOption.Value);
    let entry = { id: catalogId, value: value };
    let ref = optionValue.findIndex((x) => x.id === catalogId);
    if (ref > -1) optionValue[ref] = entry;
    else optionValue.push(entry);
    profileOption.Value = JSON.stringify(optionValue);
  };

  if (profileOption.Value == null) profileOption.Value = "[]";

  return (
    <Stack
      direction={"column"}
      justifyContent={"space-between"}
      style={{ minHeight: "50px" }}
    >
      <FormLabel>{optionSchema.OptionName}</FormLabel>
      {profileOption.CatalogRecordList &&
        profileOption.CatalogRecordList.map((record, k) => {
          let optionValue = JSON.parse(profileOption.Value);
          let catalogValue = optionValue.find((x) => x.id === record.Id);
          if (catalogValue == null) catalogValue = { id: 0, value: -1 };

          return (
            <Stack
              key={k}
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              style={{ minHeight: "50px" }}
            >
              <FormLabel>{record.Code}</FormLabel>
              <RadioGroup
                value={catalogValue.value}
                onChange={(event) => {
                  applyNewCatalogValue(record.Id, event.target.value);
                  dispatch(
                    updateOption({
                      option: profileOption,
                      isGlobal: isGlobal,
                    })
                  );
                }}
              >
                <Stack direction={"row"} style={{ marginLeft: "8px" }}>
                  {Object.keys(optionSchema.ValueList).map((value, l) => (
                    <FormControlLabel
                      key={l}
                      value={value}
                      control={<Radio />}
                      label={optionSchema.ValueList[value]}
                    />
                  ))}
                </Stack>
              </RadioGroup>
            </Stack>
          );
        })}
    </Stack>
  );
};
const ConfigurableFeatureCard = ({ feature, isGlobal }) => {
  const dispatch = useDispatch();
  let connectionProfile = useSelector(selectConnectionProfile);
  let globalProfile = useSelector(selectGlobalProfile);

  const OptionType = { Radio: 1, NumericInput: 3, Catalog: 5, Catalog_Grid: 6 };

  const getOptionFromProfile = (optionId) => {
    let profileValue = connectionProfile.Options.find(
      (x) => x.OptionId === optionId
    );
    if (profileValue == null) return null;

    return JSON.parse(JSON.stringify(profileValue)); //deepcopy since state is readonly
  };
  const getOptionFromGlobal = (optionId) => {
    let globalValue = globalProfile.Options.find(
      (x) => x.OptionId === optionId
    );
    if (globalValue == null) return null;
    return JSON.parse(JSON.stringify(globalValue)); //deepcopy since state is readonly
  };

  const saveConfigOptions = (optionIds, isGlobal) => {
    let options = [];
    let url;
    if (!isGlobal) {
      optionIds.forEach((optionId) => {
        options.push(
          connectionProfile.Options.find((x) => x.OptionId === optionId)
        );
      });
    } else {
      optionIds.forEach((optionId) => {
        options.push(
          globalProfile.Options.find((x) => x.OptionId === optionId)
        );
      });
    }
    axios
      .put(
        `/operations/connection-profiles/${connectionProfile.OperationId}/option`,
        {
          ConnectionProfileOptions: options
        },
        {
          params: {
            operationId: connectionProfile.OperationId,
            connectionPairId: connectionProfile.ConnectionPairId,
            isGlobal: isGlobal,
          },
        }
      )
      .catch((error) => {
        console.error("Error saving option:", error);
      });
  };

  return (
    <Stack direction={"row"} style={{ width: "100%" }}>
      <SettingsCard
        title={feature.FunctionName}
        description={feature.FunctionDescription}
        className="config-options-card"
        style={{ width: "45%", marginLeft: 0, flexGrow: 1 }}
      >
        {feature.OperationOptions.map((option, j) => {
          let profileOption = null;
          if (isGlobal) profileOption = getOptionFromGlobal(option.OptionId);
          else profileOption = getOptionFromProfile(option.OptionId);

          if (profileOption == null) return;

          let disableNotGlobal = !isGlobal && profileOption.UseGlobal;

          return (
            <Fragment key={j}>
              {option.OptionInputType === OptionType.Radio &&
                Object.keys(option.ValueList).length <= 3 && (
                  <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    style={{ minHeight: "50px" }}
                  >
                    <FormLabel>{option.OptionName}</FormLabel>
                    <RadioGroup
                      value={profileOption.Value}
                      onChange={(event) => {
                        profileOption.Value = event.target.value;
                        dispatch(
                          updateOption({
                            option: profileOption,
                            isGlobal: isGlobal,
                          })
                        );
                      }}
                    >
                      <Stack direction={"row"} style={{ marginLeft: "8px" }}>
                        {Object.keys(option.ValueList).map((value, k) => (
                          <FormControlLabel
                            disabled={disableNotGlobal}
                            key={k}
                            value={value}
                            control={<Radio />}
                            label={option.ValueList[value]}
                          />
                        ))}
                      </Stack>
                    </RadioGroup>
                  </Stack>
                )}
              {option.OptionInputType === OptionType.Radio &&
                Object.keys(option.ValueList).length > 3 && (
                  <FormControl>
                    <FormLabel style={{ marginBottom: "12px" }}>
                      {option.OptionName}
                    </FormLabel>
                    <RadioGroup
                      value={profileOption.Value}
                      onChange={(event) => {
                        profileOption.Value = event.target.value;
                        dispatch(
                          updateOption({
                            option: profileOption,
                            isGlobal: isGlobal,
                          })
                        );
                      }}
                    >
                      <Grid container columns={2}>
                        {Object.keys(option.ValueList).map((value, k) => (
                          <Grid item xs={1} key={k}>
                            <FormControlLabel
                              disabled={disableNotGlobal}
                              value={value}
                              control={<Radio />}
                              label={option.ValueList[value]}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </RadioGroup>
                  </FormControl>
                )}
              {option.OptionInputType === OptionType.NumericInput && (
                <FormControl>
                  <Stack
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                  >
                    <FormLabel style={{ marginRight: "8px" }}>
                      {option.OptionName}
                    </FormLabel>
                    <TextField
                      style={{ marginLeft: "16px" }}
                      disabled={disableNotGlobal}
                      value={profileOption.Value}
                      onChange={(event) => {
                        profileOption.Value = event.target.value;
                        dispatch(
                          updateOption({
                            option: profileOption,
                            isGlobal: isGlobal,
                          })
                        );
                      }}
                    />
                  </Stack>
                </FormControl>
              )}
              {option.OptionInputType === OptionType.Catalog && !isGlobal && (
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  style={{ minHeight: "50px" }}
                >
                  <FormLabel>{option.OptionName}</FormLabel>
                  {profileOption.CatalogRecordList && (
                    <Dropdown
                      width={300}
                      label=""
                      onChange={(event) => {
                        profileOption.Value = event.target.value;
                        dispatch(
                          updateOption({
                            option: profileOption,
                            isGlobal: isGlobal,
                          })
                        );
                      }}
                      value={profileOption.Value}
                      options={profileOption.CatalogRecordList.map((x) => {
                        return { key: x.Id, label: x.Code + " | " + x.Name };
                      })}
                    ></Dropdown>
                  )}
                </Stack>
              )}
              {option.OptionInputType === OptionType.Catalog_Grid &&
                !isGlobal && (
                  <CatalogGridCard
                    optionSchema={option}
                    profileOption={profileOption}
                    isGlobal={isGlobal}
                  />
                )}
              {(option.OptionInputType === OptionType.Catalog ||
                option.OptionInputType === OptionType.Catalog_Grid) &&
                isGlobal && (
                  <Stack
                    key={j}
                    direction={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    style={{ minHeight: "50px" }}
                  >
                    <FormLabel>
                      {
                        "No Global Settings. Option must be set per Connection Pair."
                      }
                    </FormLabel>
                  </Stack>
                )}
            </Fragment>
          );
        })}
      </SettingsCard>
      <Card className="config-save-card">
        <IconButton
          onClick={() => {
            let optionIds = [];
            feature.OperationOptions.map((option) => {
              optionIds.push(option.OptionId);
            });
            saveConfigOptions(optionIds, isGlobal);
          }}
          label={"Save"}
          iconSize={50}
          icon={SaveInactive}
          iconHover={SaveHover}
          iconClicked={SaveInactive}
          hideShadow={true}
        />
      </Card>
      {!isGlobal && (
        <>
          <SettingsCard
            title={"Global Setting"}
            description={feature.FunctionDescription}
            className="config-options-card"
            style={{ width: "45%", marginLeft: 8, flexGrow: 1 }}
          >
            {feature.OperationOptions.map((option, j) => {
              let profileOption = getOptionFromProfile(option.OptionId);
              let globalOption = getOptionFromGlobal(option.OptionId);

              if (profileOption == null || globalOption == null) return;

              if (
                option.OptionInputType === OptionType.Catalog ||
                option.OptionInputType === OptionType.Catalog_Grid
              )
                return (
                  <Stack
                    key={j}
                    direction={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    style={{ minHeight: "50px" }}
                  >
                    <FormLabel>
                      {
                        "No Global Settings. Option must be set per Connection Pair."
                      }
                    </FormLabel>
                    <FormControlLabel
                      control={<Checkbox checked={false} disabled={true} />}
                      label="Use Global Setting"
                      style={{ marginLeft: 5, minWidth: 180 }}
                    />
                  </Stack>
                );
              else
                return (
                  <Stack
                    key={j}
                    direction={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    style={{ minHeight: "50px" }}
                  >
                    <FormLabel className="global-option">
                      {"Global " + option.OptionName + " is configured as "}
                      <strong>
                        {option.ValueList
                          ? option.ValueList[globalOption.Value]
                          : globalOption.Value}
                      </strong>
                    </FormLabel>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={profileOption.UseGlobal}
                          onChange={() => {
                            profileOption.UseGlobal = !profileOption.UseGlobal;
                            dispatch(updateOption({ option: profileOption }));
                          }}
                        />
                      }
                      label="Use Global Setting"
                      style={{ marginLeft: 5, minWidth: 180 }}
                    />
                  </Stack>
                );
            })}
          </SettingsCard>
          <Card className="config-save-card">
            <IconButton
              onClick={() => {
                let optionIds = [];
                feature.OperationOptions.map((option) => {
                  optionIds.push(option.OptionId);
                });
                saveConfigOptions(optionIds, isGlobal);
              }}
              label={"Save"}
              iconSize={50}
              icon={SaveInactive}
              iconHover={SaveHover}
              iconClicked={SaveInactive}
              hideShadow={true}
            />
          </Card>
        </>
      )}
    </Stack>
  );
};
const ConfigurableFeatureSection = ({ configurableFeatures, isGlobal }) => {
  return (
    <MenuBlock
      title="Process settings - Configurable Features"
      subMenu={true}
      maxHeight={3000}
      duration={1500}
    >
      {configurableFeatures.map((feature, i) => (
        <ConfigurableFeatureCard
          key={i}
          feature={feature}
          type={feature.Category}
          isGlobal={isGlobal}
        />
      ))}
    </MenuBlock>
  );
};
const SettingsCard = ({ title, description, style, onSave, children }) => {
  return (
    <Card style={style}>
      <Typography className="title-header" variant="h3">
        {title}
      </Typography>
      <Typography variant="p">{description}</Typography>
      <Box style={{ marginTop: 12, paddingTop: 50 }}>{children}</Box>
      {onSave && (
        <Stack direction={"row-reverse"}>
          <Button
            className="btn-primary"
            style={{ width: 180 }}
            onClick={onSave}
          >
            Save
          </Button>
        </Stack>
      )}
    </Card>
  );
};

const Settings = () => {
  const dispatch = useDispatch();
  const [operationsSchema, setOperationsSchema] = useState({
    StandardFeatures: [],
    ConfigurableFeatures: [],
  });
  const [isGlobal, setIsGlobal] = useState(false);
  const [connProfileOpenPopUp, setConnProfileOpenPopUp] = useState(false);
  const cycleId = useSelector(selectCurrentCycleId);
  const currentOperationId = useSelector(selectCurrentOperationId);
  const connectionProfile = useSelector(selectConnectionProfile);
  const connectionProfileStatus = useSelector(getConnectionProfileStatus);
  const globalProfileStatus = useSelector(getGlobalProfileStatus);
  const currentConnectionPair = useSelector(selectCurrentConnectionPair);
  const currentOperationName = useSelector(selectCurrentOperationName);

  useEffect(() => {
    loadOperationsSchema();
    if (!connectionProfileStatus.includes("loading")) {
      dispatch(
        fetchConnectionProfile({
          operationId: currentOperationId,
          connectionPairId: currentConnectionPair.connectionPairId,
        })
      );
    }
    if (!globalProfileStatus.includes("loading")) {
      dispatch(
        fetchGlobalProfile({
          operationId: currentOperationId,
        })
      );
    }
  }, [currentOperationId, currentConnectionPair]);

  const loadOperationsSchema = () => {
    axios
      .get("/operations/schema", {
        params: {
          cycleId: cycleId,
          operationId: currentOperationId,
        },
      })
      .then((response) => {
        if (
          response.data.ConfigurableFeatures == null &&
          response.data.StandardFeatures == null
        )
          setOperationsSchema({
            StandardFeatures: [],
            ConfigurableFeatures: [],
          });
        else setOperationsSchema(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  //popUp section

  //// Use useLocation and URLSearchParams to get the query parameters (checkedValues)
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  //code to route to the Global settings with the parameters like header value and the checked checkbox names

  const onChangePreReqStage = (operationId) => {
    if (operationId.length === 1) {
      let updatedProfile = JSON.parse(JSON.stringify(connectionProfile));
      updatedProfile.PreReqOperationId = operationId[0];
      dispatch(setConnectionProfile({ connectionProfile: updatedProfile }));
    }
  };
  const onChangeNextStage = (operationId) => {
    if (operationId.length === 1) {
      let updatedProfile = JSON.parse(JSON.stringify(connectionProfile));
      updatedProfile.NextOperationId = operationId[0];
      dispatch(setConnectionProfile({ connectionProfile: updatedProfile }));
    }
  };

  const onChangeReceivingConnectionId = (event) => {
    let value = event.target.value;
    if (value === connectionProfile.ReceivingConnectionId) return;

    let updatedProfile = JSON.parse(JSON.stringify(connectionProfile));
    updatedProfile.SendingConnectionId =
      currentConnectionPair.connectionId1 === value
        ? currentConnectionPair.connectionId2
        : currentConnectionPair.connectionId1;
    updatedProfile.ReceivingConnectionId = value;
    dispatch(setConnectionProfile({ connectionProfile: updatedProfile }));
  };

  const onChangeSendingConnectionId = (event) => {
    let value = event.target.value;
    if (value === connectionProfile.SendingConnectionId) return;

    let updatedProfile = JSON.parse(JSON.stringify(connectionProfile));
    updatedProfile.ReceivingConnectionId =
      currentConnectionPair.connectionId1 === value
        ? currentConnectionPair.connectionId2
        : currentConnectionPair.connectionId1;
    updatedProfile.SendingConnectionId = value;
    dispatch(setConnectionProfile({ connectionProfile: updatedProfile }));
  };

  const saveMainOptions = (field, value) => {
    axios
      .put(
        `/operations/connection-profiles/${connectionProfile.OperationId}/field`,
        null,
        {
          params: {
            operationId: connectionProfile.OperationId,
            connectionPairId: connectionProfile.ConnectionPairId,
            field: field,
            value: value,
          },
        }
      )
      .catch((error) => {
        console.error("Error saving option:", error);
      });
  };

  return (
    <Container>
      <MainNavigation />
      <Container className="page-wrapper">
        <Typography variant="h2">{currentOperationName}</Typography>
        <OperationsNavigation forceSelection={true} />
        <SummaryCard
          stageName={currentOperationName}
          connectionPairName={currentConnectionPair.connectionPairName}
          isGlobal={isGlobal}
        />
        <Stack className="settings-btn-stack">
          <Button
            variant="contained"
            className="settings-connectionProfile-btn"
            onClick={() => {
              setConnProfileOpenPopUp(true);
            }}
          >
            <img
              src={ChangeConnectionProfileInactive}
              className="connectionProfile-button-icon"
            />
            {isGlobal
              ? "Select Connection Profile"
              : "Change Connection Profile"}
          </Button>
          <PopUp
            size={"large"}
            openPopUp={connProfileOpenPopUp}
            setOpenPopUp={setConnProfileOpenPopUp}
          >
            <SettingsPopUp
              showStage={false}
              onClose={() => {
                setConnProfileOpenPopUp(false);
                setIsGlobal(false);
              }}
            />
          </PopUp>
          {!isGlobal && (
            <Button
              variant="contained"
              className="settings-globalSetting-btn"
              onClick={() => setIsGlobal(!isGlobal)}
            >
              <img
                className="globalSetting-button-icon"
                src={GlobalSettingInactive}
              />
              Global Setting
            </Button>
          )}
        </Stack>
        {connectionProfile.OperationId != null && (
          <>
            <MenuBlock
              title="Receive Settings"
              maxHeight={1500}
              iconInactive={ReceiveSettingsInactive}
              iconHover={ReceiveSettingsHover}
            >
              {!isGlobal && (
                <SettingsCard
                  title="Select Connection Receiving"
                  description="
              Select a connection from your connection profile to be used when
              receiving for this operations."
                  onSave={() => {
                    saveMainOptions(
                      "ReceivingConnectionId",
                      connectionProfile.ReceivingConnectionId
                    );
                    saveMainOptions(
                      "SendingConnectionId",
                      connectionProfile.SendingConnectionId
                    );
                  }}
                >
                  <Dropdown
                    width={300}
                    label="Select Connection"
                    value={connectionProfile.ReceivingConnectionId}
                    options={[
                      {
                        key: currentConnectionPair.connectionId1,
                        label: currentConnectionPair.connectionName1,
                      },
                      {
                        key: currentConnectionPair.connectionId2,
                        label: currentConnectionPair.connectionName2,
                      },
                    ]}
                    onChange={onChangeReceivingConnectionId}
                  ></Dropdown>
                </SettingsCard>
              )}
              <SettingsCard
                title="Set Stage Sequence"
                description="
              Set the pre-requisite stage that must complete before this stage can run."
                onSave={() => {
                  saveMainOptions(
                    "PreReqOperationId",
                    connectionProfile.PreReqOperationId
                  );
                }}
              >
                <StageCheckbox
                  selectedStages={
                    connectionProfile.PreReqOperationId
                      ? [connectionProfile.PreReqOperationId]
                      : []
                  }
                  onCheckboxChange={onChangePreReqStage}
                />
              </SettingsCard>
            </MenuBlock>
            <MenuBlock
              title="Process settings"
              maxHeight={4000}
              iconInactive={ProcessSettingsInactive}
              iconHover={ProcessSettingsHover}
              duration={1500}
            >
              <MenuBlock
                title="Process settings  - Standard Features"
                subMenu={true}
                maxHeight={950}
              >
                <SettingsCard
                  description="These features will be automatically applied as part of these
              operation."
                >
                  <Grid container column={2}>
                    {operationsSchema.StandardFeatures.map((feature, i) => (
                      <p key={i} style={{ margin: 3, width: "49%" }}>
                        {"- " + feature}
                      </p>
                    ))}
                  </Grid>
                </SettingsCard>
              </MenuBlock>
              <ConfigurableFeatureSection
                configurableFeatures={operationsSchema.ConfigurableFeatures}
                isGlobal={isGlobal}
              />
              <SettingsCard
                title="Apply Custom Logic"
                description="
              Define Custom logic / Script"
              >
                <Button className="btn-primary" style={{ width: 240 }}>
                  Apply Customer Logic
                </Button>
              </SettingsCard>
              <SettingsCard
                title="Apply Inbound Data Map"
                description="
              Define Custom logic / Script"
              >
                <Button className="btn-primary" style={{ width: 240 }}>
                  Apply Inbound Data Map
                </Button>
              </SettingsCard>
              <SettingsCard
                title="Maintenance"
                description="
              Click on the references blow to maintain the references used by this operation."
              ></SettingsCard>
              <SettingsCard
                title="Notification"
                description="
              Please select notifaction profile to be used for this operation."
                onSave={() => {}}
              >
                <Dropdown
                  width={300}
                  label="Select Connection"
                  options={[]}
                ></Dropdown>
              </SettingsCard>
            </MenuBlock>
            <MenuBlock
              title="Process Confirmation settings"
              maxHeight={1200}
              iconInactive={ProcessConfirmationInactive}
              iconHover={ProcessConfirmationHover}
            >
              {!isGlobal && (
                <SettingsCard
                  title="Connection for Sending"
                  description="
              Select a connection from your connection profile to be used when
              sending for this operations."
                  onSave={() => {
                    saveMainOptions(
                      "SendingConnectionId",
                      connectionProfile.SendingConnectionId
                    );
                    saveMainOptions(
                      "ReceivingConnectionId",
                      connectionProfile.ReceivingConnectionId
                    );
                  }}
                >
                  <Dropdown
                    width={300}
                    label="Select Connection"
                    value={connectionProfile.SendingConnectionId}
                    options={[
                      {
                        key: currentConnectionPair.connectionId1,
                        label: currentConnectionPair.connectionName1,
                      },
                      {
                        key: currentConnectionPair.connectionId2,
                        label: currentConnectionPair.connectionName2,
                      },
                    ]}
                    onChange={onChangeSendingConnectionId}
                  ></Dropdown>
                </SettingsCard>
              )}
              <SettingsCard
                title="Set Next Stage"
                description="
              Set the next stage you would like the platform to complete based on your business requirements. Note this setting affect both the scheduled opertations (automation) as well as menually running this operation."
                onSave={() => {
                  saveMainOptions(
                    "NextOperationId",
                    connectionProfile.NextOperationId
                  );
                }}
              >
                <StageCheckbox
                  selectedStages={
                    connectionProfile.NextOperationId
                      ? [connectionProfile.NextOperationId]
                      : []
                  }
                  onCheckboxChange={onChangeNextStage}
                />
              </SettingsCard>
            </MenuBlock>
          </>
        )}
      </Container>
    </Container>
  );
};

export default Settings;
